module.exports = __webpack_public_path__ + "static/media/bg.5eef3ae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/bg.jpg
// module id = 1059
// module chunks = 0